if (!customElements.get('np-product-bundle')) {
  customElements.define('np-product-bundle', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.main = this.querySelector('[data-bundle-main]');
      this.button = this.querySelector('[data-bundle-add]');
      this.status = this.querySelector('[data-bundle-status]');
      this.format = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
      this.addEventListener('change', () => this.update(), options);
      this.button.addEventListener('click', () => this.add(), options);
      const section = this.closest('.shopify-section');
      this.selection = section.querySelector('[data-variant-selection]');
      if (this.selection) {
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.selection, { attributes:true, attributeFilter:['variant'] });
      }
      const data = section.querySelector('[data-section-data]');
      try { this.variants = JSON.parse(data.textContent).product.variants; } catch { this.variants = []; }
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    update() {
      const id = this.selection?.getAttribute('variant') || this.main.dataset.id;
      const variant = this.variants.find(item => String(item.id) === id);
      if (variant) {
        this.main.dataset.id = variant.id;
        this.main.dataset.price = variant.price;
        this.querySelector('[data-bundle-main-price]').textContent = this.format.format(variant.price / 100);
      }
      this.button.disabled = Boolean(this.pending) || !variant || !variant.available;
      const total = [...this.querySelectorAll('[data-bundle-item]:checked')].reduce((sum, item) => sum + Number(item.dataset.price), Number(this.main.dataset.price));
      this.querySelector('[data-bundle-total]').textContent = this.format.format(total / 100);
    }
    async add() {
      if (this.pending || this.button.disabled) return;
      this.pending = true;
      this.button.disabled = true;
      this.status.textContent = 'Adding your bundle…';
      const items = [{ id:Number(this.main.dataset.id), quantity:1 }, ...[...this.querySelectorAll('[data-bundle-item]:checked')].map(item => ({ id:Number(item.value), quantity:1 }))];
      try {
        const response = await fetch(this.dataset.addUrl, { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add the bundle. Please try again.');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) { this.status.textContent = error.message; this.pending = false; this.update(); }
    }
  });
}
if (!customElements.get('np-product-tabs')) {
  customElements.define('np-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      document.addEventListener('shopify:block:select', event => {
        const row = [...this.querySelectorAll('[data-detail-block]')].find(item => item.dataset.detailBlock === event.detail?.blockId);
        if (!row) return;
        const panel = row.closest('[role=tabpanel]');
        const tab = this.tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
        if (tab) this.select(tab);
        row.open = true;
      }, { signal:this.controller.signal });
      this.addEventListener('click', event => { const tab = event.target.closest('[role=tab]'); if (tab) this.select(tab); }, { signal:this.controller.signal });
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); this.select(this.tabs[next]); this.tabs[next].focus(); }
      }, { signal:this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    select(tab) {
      this.tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
      this.querySelectorAll('[role=tabpanel]').forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    }
  });
}

if (!customElements.get('np-gallery-stock')) {
 customElements.define('np-gallery-stock',class extends HTMLElement {
  connectedCallback() {
   const section=this.closest('.shopify-section');
   this.selection=section?.querySelector('[data-variant-selection]');
   try { this.variants=JSON.parse(section.querySelector('[data-section-data]').textContent).product.variants; } catch { return; }
   if(this.selection) { this.observer=new MutationObserver(()=>this.update()); this.observer.observe(this.selection,{attributes:true,attributeFilter:['variant']}); }
   this.update();
  }
  disconnectedCallback() { this.observer?.disconnect(); }
  update() {
   const id=this.selection?.getAttribute('variant');
   const variant=this.variants.find(item=>String(item.id)===id);
   if(!variant) { this.hidden=true; return; }
   this.hidden=false;
   this.toggleAttribute('data-sold-out',!variant.available);
   this.querySelector('[data-gallery-stock-text]').textContent=variant.available?'In Stock'+(this.dataset.shipping?' \u2022 '+this.dataset.shipping:''):'Sold Out';
  }
 });
}
